type Props = {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
};

export default function Pagination({ page, totalPages, onChange }: Props) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) pages.push(i);

  const baseBtn =
    "flex h-9 min-w-9 items-center justify-center rounded-md border px-3 text-sm transition-colors";

  return (
    <nav className="mt-8 flex flex-wrap items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={page <= 1}
        className={`${baseBtn} ${
          page <= 1
            ? "cursor-not-allowed border-background-200 text-foreground-300"
            : "border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
        }`}
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>

      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          aria-current={p === page ? "page" : undefined}
          className={`${baseBtn} ${
            p === page
              ? "border-primary-500 bg-primary-500 font-medium text-background-50"
              : "border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
          }`}
        >
          {p}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={page >= totalPages}
        className={`${baseBtn} ${
          page >= totalPages
            ? "cursor-not-allowed border-background-200 text-foreground-300"
            : "border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
        }`}
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}